import { Modal } from 'antd'
import Button from 'components/Button'
import Flex from 'components/Flex'
import React from 'react'

import styled from 'styled-components'
import RegistrationSuccessImage from '../assets/images/SuccessImage.png'

export const UploadMsgFlex = styled(Flex)`
  height: 100%;
`

export const FlexWrapRole = styled(Flex)`
  width: ${props => (props.width ? props.width : '100%')};
  gap: ${props => (props.gap ? props.gap : '0')};
  margin-left: 15px;
`
export const ShortlistDiv = styled.div`
  font-family: 'Plus Jakarta Sans';
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0em;
  text-align: center;
  color: #010e30;
  width: 451px;
  height: 28px;
  margin-top: 15px;
  margin-bottom: 15px;
`

const CustomModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 10px;
    align-content: center;
  }
  .ant-modal-body {
    padding: 145px 20px 145px 20px;
  }
  .ant-modal-mask {
    backdrop-filter: blur(10px);
  }
  .ant-modal-header {
    background: transparent;
  }
`

const Description = styled.div`
  font-family: Plus Jakarta Sans;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  display: flex;
  gap: 5px;
  align-items: baseline;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 30px;
`

const SuccessModal = ({ open, onCloseClick, message, title='Registration' }) => {
  return (
    <CustomModal
      open={open}
      centered
      footer={null}
      // maskClosable={false} // Prevent closing the modal when clicking outside
      closable={false} // Hide the close button
      width={836}
      height={434}
      title={title}
      onCancel={onCloseClick}
    >
      <Flex column>
        <FlexWrapRole center>
          <img src={RegistrationSuccessImage} alt="success" />
        </FlexWrapRole>
        <Description>{message}</Description>
        <FlexWrapRole gap="20px" center>
          <Button.Secondary
            text="Close"
            width="80px"
            height="38px"
            onClick={() => {
              onCloseClick()
            }}
          />
        </FlexWrapRole>
      </Flex>
    </CustomModal>
  )
}

export default SuccessModal
